import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export * from '@/scripts/FreeMode/FreeModeBook/FreeModeBook.service';

export const getBook = bookId => httpClient.get(apis.GET_READER_CENTER_FREE_BOOK + bookId);
